import './nav.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";

function MyFooter() {
  return (
    <footer className="footerContainer">
      <h2 className="footerText">Siya Choudhary © {new Date().getFullYear()}</h2>
      <ul className="footerIcons">
        {/* <li><a href="https://www.instagram.com/siyac_art/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a></li> */}
        <li><a href="https://www.linkedin.com/in/siya-choudhary-2b0b89229/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a></li>
        <li><a href="https://github.com/siyachoudhary" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faGithub} /></a></li>
      </ul>
    </footer>
  );
}

export default MyFooter;